import React, { useState } from 'react';
import '../pages/ManageSMRTCOP.css';

export default function LoginAsPanel({ embedded = false }: { embedded?: boolean }) {
  const [expanded, setExpanded] = useState(false);
  const isOpen = embedded || expanded;

  return (
    <div style={{ marginBottom: 16 }}>
      {!embedded && (
      <div
        style={{
          position: 'sticky',
          top: '5rem',
          zIndex: 10,
          background: '#1a1a1a',
          padding: '10px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: 6,
          color: '#9aa0a6',
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          fontSize: '0.8rem',
          fontWeight: 600,
        }}
      >
        <div
          onClick={() => setExpanded((v) => !v)}
          style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}
        >
          <span style={{ fontSize: '0.85rem' }}>{expanded ? '▼' : '▶'}</span>
          <h2 style={{ margin: 0, fontSize: '0.9rem', fontWeight: 600, color: '#cbd5e1', textTransform: 'none', letterSpacing: 'normal' }}>LoginAs</h2>
        </div>
      </div>
      )}

      {isOpen && (
        <div style={{ background: '#1e1e1e', borderRadius: 8, padding: 24, marginTop: 8, color: '#9aa0a6', fontSize: '0.9rem', textAlign: 'center' }}>
          Coming soon
        </div>
      )}
    </div>
  );
}
